// Zweck: Eindeutige Gewerkeauswahl für Nacharbeit und Abschlussbericht (1697).
import { useId } from 'react';
export default function ReworkTradeSelector({ value = 'SHK', onChange, disabled = false }: {
  readonly value?: 'SHK' | 'Elektro'; readonly onChange: (value: 'SHK' | 'Elektro') => void; readonly disabled?: boolean;
}) {
  const name = useId();
  return <fieldset disabled={disabled} className="my-3 text-gray-900 dark:text-gray-100"><legend className="font-medium">Gewerk</legend>
    <div className="flex flex-wrap gap-4">{(['SHK', 'Elektro'] as const).map(trade => <label key={trade} className="inline-flex min-h-[44px] items-center gap-2 cursor-pointer">
      <input type="radio" name={name} value={trade} checked={value === trade} onChange={() => onChange(trade)} />{trade}
    </label>)}</div>
  </fieldset>;
}
